import axios from 'axios';

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BETTEREZ_BASE_URL + '/btrz-pay/',
  headers: {
    'x-api-key': process.env.VUE_APP_BETTEREZ_X_API_KEY,
  },
});
export default {
  getPaymentMethods() {
    return HTTP.get('payment-methods', {
      params: {
        channel: 'websales',
        //providerId: '52f862392433e2310400004d',
        enabled: true,
      },
    });
  },
};
